type TabItem = string | { id: string; label: string; icon?: string };

interface FilterTabsProps {
  tabs?: TabItem[];
  filters?: string[];
  activeTab?: string;
  activeFilter?: string;
  onTabChange?: (tab: string) => void;
  onFilterChange?: (filter: string) => void;
}

export default function FilterTabs({
  tabs,
  filters,
  activeTab,
  activeFilter,
  onTabChange,
  onFilterChange,
}: FilterTabsProps) {
  const items: TabItem[] = tabs ?? filters ?? [];
  const active = activeTab ?? activeFilter ?? '';
  const handleChange = onTabChange ?? onFilterChange ?? (() => {});

  const getId = (item: TabItem) => (typeof item === 'string' ? item : item.id);
  const getLabel = (item: TabItem) => (typeof item === 'string' ? item : item.label);

  return (
    <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2">
      {items.map((item) => {
        const id = getId(item);
        const label = getLabel(item);
        return (
          <button
            key={id}
            onClick={() => handleChange(id)}
            className={`px-6 py-2.5 rounded-full font-semibold text-sm transition-all whitespace-nowrap cursor-pointer ${
              active === id
                ? 'bg-green-600 text-white shadow-md'
                : 'bg-white text-gray-700 border border-gray-300 hover:border-green-600 hover:text-green-600'
            }`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
